import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table} from 'react-bootstrap';
import Sidebar from './Sidebar';
import configAdmin from './configAdmin.json';
import ToastConfirmation from './ToastConfirmation';
import {
  getLayersConfig,
  updateLayersConfig,
  getMainConfig
} from './apiCalls';

const { HOMEPAGE_CODE, LINKS_RRSS, ODISEA_FORM } = configAdmin

export default function LayersConfiguration() {

  const [showToaster, setShowToaster] = useState(false);
  const [layersConfig, setLayersConfig] = useState({});
  const [layersConfigFormData, setLayersConfigFormData] = useState({});
  const [mainConfig, setMainConfig] = useState({});

  useEffect(() => {
    getLayersConfig(setLayersConfig);
    getMainConfig(setMainConfig);
  }, []);

  const submitForm = () => {
    updateLayersConfig({
      'DAM': {
        ...layersConfig.DAM,
        ...layersConfigFormData.DAM
      },
      'DAMI': {
        ...layersConfig.DAMI,
        ...layersConfigFormData.DAMI
      },
      'DAME': {
        ...layersConfig.DAME,
        ...layersConfigFormData.DAME
      }
    })
    .then(() => setShowToaster(true));
  }

  const layersFormContent = (
    <Form>
      <h4>DAM</h4>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">DAM GEOJSON</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAM')}
          defaultValue={ layersConfig?.DAM?.geoJSON && layersConfig["DAM"]["geoJSON"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAM ? formData = {...formData, 'DAM': {...formData.DAM, 'geoJSON': e.target.value}} : formData = {...formData, 'DAM': {'geoJSON': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">DAM GEOJSON Centroides</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAM')}
          defaultValue={ layersConfig?.DAM?.centroids && layersConfig["DAM"]["centroids"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAM ? formData = {...formData, 'DAM': {...formData.DAM, 'centroids': e.target.value}} : formData = {...formData, 'DAM': {'centroids': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Código GEOJSON (DAM)</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAM')}
          defaultValue={ layersConfig?.DAM?.codeFeature && layersConfig["DAM"]["codeFeature"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAM ? formData = {...formData, 'DAM': {...formData.DAM, 'codeFeature': e.target.value}} : formData = {...formData, 'DAM': {'codeFeature': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Código numérico GEOJSON (DAM)</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAM')}
          defaultValue={ layersConfig?.DAM?.codeFeatureNum && layersConfig["DAM"]["codeFeatureNum"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAM ? formData = {...formData, 'DAM': {...formData.DAM, 'codeFeatureNum': e.target.value}} : formData = {...formData, 'DAM': {'codeFeatureNum': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <h4>DAMI</h4>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">DAMI GEOJSON</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAMI')}
          defaultValue={ layersConfig?.DAMI?.geoJSON && layersConfig["DAMI"]["geoJSON"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAMI ? formData = {...formData, 'DAMI': {...formData.DAMI, 'geoJSON': e.target.value}} : formData = {...formData, 'DAMI': {'geoJSON': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">DAMI GEOJSON Centroides</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAMI')}
          defaultValue={ layersConfig?.DAMI?.centroids && layersConfig["DAMI"]["centroids"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAMI ? formData = {...formData, 'DAMI': {...formData.DAMI, 'centroids': e.target.value}} : formData = {...formData, 'DAMI': {'centroids': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Código GEOJSON (DAMI)</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAMI')}
          defaultValue={ layersConfig?.DAMI?.codeFeature && layersConfig["DAMI"]["codeFeature"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAMI ? formData = {...formData, 'DAMI': {...formData.DAMI, 'codeFeature': e.target.value}} : formData = {...formData, 'DAMI': {'codeFeature': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Código numérico GEOJSON (DAMI)</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAMI')}
          defaultValue={ layersConfig?.DAMI?.codeFeatureNum && layersConfig["DAMI"]["codeFeatureNum"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAMI ? formData = {...formData, 'DAMI': {...formData.DAMI, 'codeFeatureNum': e.target.value}} : formData = {...formData, 'DAMI': {'codeFeatureNum': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <h4>DAME</h4>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">DAME GEOJSON</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAME')}
          defaultValue={ layersConfig?.DAME?.geoJSON && layersConfig["DAME"]["geoJSON"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAME ? formData = {...formData, 'DAME': {...formData.DAME, 'geoJSON': e.target.value}} : formData = {...formData, 'DAME': {'geoJSON': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">DAME GEOJSON Centroides</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAME')}
          defaultValue={ layersConfig?.DAME?.centroids && layersConfig["DAME"]["centroids"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAME ? formData = {...formData, 'DAME': {...formData.DAME, 'centroids': e.target.value}} : formData = {...formData, 'DAME': {'centroids': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Código GEOJSON (DAME)</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAME')}
          defaultValue={ layersConfig?.DAME?.codeFeature && layersConfig["DAME"]["codeFeature"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAME ? formData = {...formData, 'DAME': {...formData.DAME, 'codeFeature': e.target.value}} : formData = {...formData, 'DAME': {'codeFeature': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Código numérico GEOJSON (DAME)</Form.Label>
        <Form.Control
          placeholder=""
          disabled={mainConfig && mainConfig?.enabledDA && !mainConfig.enabledDA.includes('DAME')}
          defaultValue={ layersConfig?.DAME?.codeFeatureNum && layersConfig["DAME"]["codeFeatureNum"] }
          onChange={ (e) => {
            let formData = layersConfigFormData;
            formData?.DAME ? formData = {...formData, 'DAME': {...formData.DAME, 'codeFeatureNum': e.target.value}} : formData = {...formData, 'DAME': {'codeFeatureNum': e.target.value}};
            setLayersConfigFormData(formData);
          } }  
        />
      </Form.Group>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>
    </Form>
  )

  return (
    <Container fluid>
      {/* JSON.stringify(layersConfigFormData) */}
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
            <Card>
              <Card.Header>Layers de mapas</Card.Header>
              <Card.Body>{ layersFormContent }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
